<nz-form-item>
  <div style="padding: 6px">
    <label [attr.for]="inputId" [ngClass]="labelClass" [class.required-label]="required">{{ label }}</label>
    @if (secondLabel) {
    <label [attr.for]="inputId" [ngClass]="secondLabelClass" style="margin-left: 4px">{{ secondLabel }}</label>
    }
  </div>
  <nz-form-control [nzValidateStatus]="convertErrorsNz[inputFormControl.status]">
    <input nz-input [type]="inputType" [id]="inputId" [formControl]="asFormControl(inputFormControl)" />
    <app-form-item-error [touched]="inputFormControl.touched" [errors]="inputFormControl.errors"></app-form-item-error>
  </nz-form-control>
</nz-form-item>
